import { EditableComment } from '../job-activity.state';

const statusStyles: Record<string, { icon: string; color: string }> = {
  failed: { icon: 'pi-times-circle', color: '#dc2626' },
  undelivered: { icon: 'pi-times-circle', color: '#dc2626' },
  pending: { icon: 'pi-clock', color: '#facc15' },
  sent: { icon: 'pi-mobile', color: '#3b82f6' },
  delivered: { icon: 'pi-check-circle', color: '#16a34a' },
};

export function mapCommentSmsStatus(
	comment: EditableComment,
) {

	const smsStatus: string = comment?.metadata?.sms_status;
	if (!smsStatus) return null;

	const style = statusStyles[smsStatus] || { icon: 'pi-mobile', color: '#6b7280' };

	const sentTo = comment.metadata.sent_to;
	const recipients: string[] = Array.isArray(sentTo) ? sentTo : sentTo ? [ sentTo ] : [];

	return {
	  icon: 'pi ' + style.icon,
	  color: style.color,
	  tooltip: [
		{
		  status: smsStatus,
		  recipients,
		},
	  ],
	};
}
